import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModulosSelecaoService } from 'src/app/filtro-lateral/service/modulos/modulos-selecao-id/modulos-selecao-id.service';
import { ModuloSelecionadoService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulo-selecionado.service';
import { ModalAvaliacaoComponent } from 'src/app/shared/components/modais/modal-avaliacao/modal-avaliacao.component';
import { ModalPerfilUsuarioComponent } from 'src/app/shared/components/modais/modal-perfil-usuario/modal-perfil-usuario.component';
import { ModalAtualizacaoCadastroComponent } from 'src/app/shared/components/modal-atualizacao-cadastro/modal-atualizacao-cadastro.component';
import { DashboardService } from 'src/app/shared/services/dashboard/dashboard.service';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { ModalAtualizacaoCadastroService } from 'src/app/shared/services/modal-atualizacao-cadastro/modal-atualizacao-cadastro.service';
import { ModalPesquisaService } from 'src/app/shared/services/modal-pesquisa/modal-pesquisa.service';
import { environment } from 'src/environments/environment';
import { SharedDataObraService } from '../ficha-da-obra/service/shared-obra/shared-obra.service';
import { ModulosBuscaService } from '../shared/components/filtros-busca/service/modulos-service/modulos.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { BlocoBuscasComponent } from './bloco-buscas/bloco-buscas.component';
import { BlocoCarteiraComponent } from './bloco-carteira/bloco-carteira.component';
import { BlocoEmpresasComponent } from './bloco-empresas/bloco-empresas.component';
import { BlocoExportacaoComponent } from './bloco-exportacao/bloco-exportacao.component';
import { BlocoTarefasComponent } from './bloco-tarefas/bloco-tarefas.component';
import { HeaderService } from './service/header.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    BlocoBuscasComponent,
    BlocoEmpresasComponent,
    BlocoTarefasComponent,
    BlocoCarteiraComponent,
    BlocoExportacaoComponent,
    RouterLink,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isFixedRoute = false;
  isFichaDaObraActive = false;
  isScrolled = false;
  bloquearMenu = false;
  desabilitarBotaoASP = false;
  primeiraPaginaCarregada = false;

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  BASE_URL_RDO: string = environment.BASE_URL_RDO;
  companyId: any;
  restrictionKey: any;
  userName: string = '';
  level: string = '';
  userId: string = '';
  exportWork: boolean = false;

  searchQuery: string = '';
  searchOption: string = 'empresa';

  menuModules: Array<any> = [];

  buscasDropdownVisible = false;
  empresasDropdownVisible = false;
  tarefasDropdownVisible = false;
  carteiraDropdownVisible = false;
  abaExportacaoVisivel = false;
  showBanner = true;
  private buscasHideTimer: any = null;
  private empresasHideTimer: any = null;
  private tarefasHideTimer: any = null;
  private carteiraHideTimer: any = null;

  bsModalRef?: BsModalRef;

  dataImplementacaoAtualizarCadastro: Date = new Date('2025-05-05T00:00:00');

  @Input() isFixed: boolean = false;

  @ViewChild('buscasMenu', { static: false }) buscasMenu!: ElementRef;
  @ViewChild('empresasMenu', { static: false }) empresasMenu!: ElementRef;
  @ViewChild('tarefasMenu', { static: false }) tarefasMenu!: ElementRef;
  @ViewChild('carteiraMenu', { static: false }) carteiraMenu!: ElementRef;

  private selecionarIdModulosService = inject(ModulosSelecaoService);
  private moduloSelecionadoService = inject(ModuloSelecionadoService);
  private readonly _headerService = inject(HeaderService);
  private readonly _errorHandleService = inject(ErrorHandleService);
  private readonly _dashboardService = inject(DashboardService);
  private readonly modalService = inject(BsModalService);
  private readonly _pedagioService = inject(ModalAtualizacaoCadastroService);
  private readonly _modalServiceAvaliacao = inject(ModalPesquisaService);
  private readonly router = inject(Router);
  private readonly sharedDataObraService = inject(SharedDataObraService);
  private readonly authService = inject(AuthService);
  private readonly modulosBuscaService = inject(ModulosBuscaService);

  get userInitials(): string {
    if (!this.userName) return '?';
    const parts = this.userName.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }

  get exibirAbaEmpresas(): boolean {
    return true;
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const pos = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.isScrolled = pos > 50;
    if (this.isScrolled) {
      this.buscasDropdownVisible = false;
      this.empresasDropdownVisible = false;
      this.tarefasDropdownVisible = false;
      this.carteiraDropdownVisible = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (
      this.buscasMenu?.nativeElement &&
      !this.buscasMenu.nativeElement.contains(target)
    ) {
      this.buscasDropdownVisible = false;
    }
    if (
      this.empresasMenu?.nativeElement &&
      !this.empresasMenu.nativeElement.contains(target)
    ) {
      this.empresasDropdownVisible = false;
    }
    if (
      this.tarefasMenu?.nativeElement &&
      !this.tarefasMenu.nativeElement.contains(target)
    ) {
      this.tarefasDropdownVisible = false;
    }
    if (
      this.carteiraMenu?.nativeElement &&
      !this.carteiraMenu.nativeElement.contains(target)
    ) {
      this.carteiraDropdownVisible = false;
    }
    if (
      !target.closest('app-bloco-exportacao') &&
      !target.closest('[data-exportacao-toggle]')
    ) {
      this.abaExportacaoVisivel = false;
    }
  }

  constructor() {
    this.companyId = this.authService.companyID;
    this.restrictionKey = this.authService.restrictionKey;
    this.userId = this.authService.userID;

    this.router.events.subscribe(() => {
      this.isFixedRoute = this.router.url === '/ficha-da-obra';
      this.buscasDropdownVisible = false;
      this.empresasDropdownVisible = false;
      this.abaExportacaoVisivel = false;
    });
  }

  ngOnInit(): void {
    this.getDadosUsuario();
    this.getDadosFornecedor();

    this.sharedDataObraService.isFichaDaObraActive$.subscribe(
      (isActive) => (this.isFichaDaObraActive = isActive),
    );
  }

  onBuscasMouseEnter(): void {
    if (this.buscasHideTimer) {
      clearTimeout(this.buscasHideTimer);
      this.buscasHideTimer = null;
    }
    this.buscasDropdownVisible = true;
  }

  onBuscasMouseLeave(): void {
    this.buscasHideTimer = setTimeout(() => {
      this.buscasDropdownVisible = false;
    }, 180);
  }

  onDropdownMouseEnter(): void {
    if (this.buscasHideTimer) {
      clearTimeout(this.buscasHideTimer);
      this.buscasHideTimer = null;
    }
  }

  onDropdownMouseLeave(): void {
    this.buscasHideTimer = setTimeout(() => {
      this.buscasDropdownVisible = false;
    }, 180);
  }

  closeBuscas(): void {
    this.buscasDropdownVisible = false;
  }

  onEmpresasMouseEnter(): void {
    if (this.empresasHideTimer) {
      clearTimeout(this.empresasHideTimer);
      this.empresasHideTimer = null;
    }
    this.empresasDropdownVisible = true;
  }

  onEmpresasMouseLeave(): void {
    this.empresasHideTimer = setTimeout(() => {
      this.empresasDropdownVisible = false;
    }, 180);
  }

  onEmpresasDropdownMouseEnter(): void {
    if (this.empresasHideTimer) {
      clearTimeout(this.empresasHideTimer);
      this.empresasHideTimer = null;
    }
  }

  onEmpresasDropdownMouseLeave(): void {
    this.empresasHideTimer = setTimeout(() => {
      this.empresasDropdownVisible = false;
    }, 180);
  }

  closeEmpresas(): void {
    this.empresasDropdownVisible = false;
  }

  onTarefasMouseEnter(): void {
    if (this.tarefasHideTimer) {
      clearTimeout(this.tarefasHideTimer);
      this.tarefasHideTimer = null;
    }
    this.tarefasDropdownVisible = true;
  }

  onTarefasMouseLeave(): void {
    this.tarefasHideTimer = setTimeout(() => {
      this.tarefasDropdownVisible = false;
    }, 180);
  }

  onTarefasDropdownMouseEnter(): void {
    if (this.tarefasHideTimer) {
      clearTimeout(this.tarefasHideTimer);
      this.tarefasHideTimer = null;
    }
  }

  onTarefasDropdownMouseLeave(): void {
    this.tarefasHideTimer = setTimeout(() => {
      this.tarefasDropdownVisible = false;
    }, 180);
  }

  closeTarefas(): void {
    this.tarefasDropdownVisible = false;
  }

  onCarteiraMouseEnter(): void {
    if (this.carteiraHideTimer) {
      clearTimeout(this.carteiraHideTimer);
      this.carteiraHideTimer = null;
    }
    this.carteiraDropdownVisible = true;
  }

  onCarteiraMouseLeave(): void {
    this.carteiraHideTimer = setTimeout(() => {
      this.carteiraDropdownVisible = false;
    }, 180);
  }

  onCarteiraDropdownMouseEnter(): void {
    if (this.carteiraHideTimer) {
      clearTimeout(this.carteiraHideTimer);
      this.carteiraHideTimer = null;
    }
  }

  onCarteiraDropdownMouseLeave(): void {
    this.carteiraHideTimer = setTimeout(() => {
      this.carteiraDropdownVisible = false;
    }, 180);
  }

  closeCarteira(): void {
    this.carteiraDropdownVisible = false;
  }

  toggleAba(selectedAba: string): void {
    const isCurrentlyVisible = this[selectedAba];
    this.buscasDropdownVisible = false;
    this.empresasDropdownVisible = false;
    this.tarefasDropdownVisible = false;
    this.carteiraDropdownVisible = false;
    this[selectedAba] = !isCurrentlyVisible;
  }

  getLinkObras(): void {
    this.router.navigate(['/obras']);
  }

  getLinkFiltros(id: number): void {
    this.moduloSelecionadoService.setModuloSelecionado(id);

    const nomeRota = this.modulosBuscaService.getRotaById(id);
    if (nomeRota) {
      this.router.navigate(['/buscas', nomeRota]);
    } else {
      console.warn(`Módulo ID ${id} não mapeado`);
    }
  }

  onSearchEnter(): void {
    const query = (this.searchQuery || '').trim();
    if (!query) return;

    if (this.searchOption === 'empresa') {
      this.handleEmpresaSearch(query);
    } else if (this.searchOption === 'id') {
      this.handleIdSearch(query);
    }
    this.clearSearchQuery();
  }

  private handleEmpresaSearch(query: string): void {
    this.router.navigate(['/empresas'], { queryParams: { termo: query } });
  }

  private handleIdSearch(query: string): void {
    this.router.navigate(['/busca/obra'], { queryParams: { termo: query } });
  }

  private clearSearchQuery(): void {
    setTimeout(() => (this.searchQuery = ''), 0);
  }

  abrirMeuPerfil(): void {
    this.router.navigate(['/usuario']);
  }

  abrirModal(): void {
    this.bsModalRef = this.modalService.show(ModalPerfilUsuarioComponent);
  }

  checkResponseNPS(): void {
    const show = sessionStorage.getItem('showNps') !== '0';
    if (show) {
      this._modalServiceAvaliacao
        .verificarRespostaNPS(this.companyId, this.restrictionKey, this.userId)
        .subscribe(
          (res) => {
            if (!res.data) {
              this.modalService.show(ModalAvaliacaoComponent, {
                class: 'modal-dialog-centered modal-nps',
                ignoreBackdropClick: true,
                keyboard: false,
              });
            }
          },
          (err) => this._errorHandleService.throwConsoleError(err),
        );
    }
  }

  verificaUsuario(): void {
    this._pedagioService
      .verificarAtualizacaoUsuario(
        this.companyId,
        this.restrictionKey,
        this.userId,
      )
      .subscribe(
        (response) => {
          if (response.data === true) {
            this.bsModalRef = this.modalService.show(
              ModalAtualizacaoCadastroComponent,
              {
                class: 'modal-dialog-centered modal-cadastro-pedadgio',
                keyboard: false,
                ignoreBackdropClick: true,
              },
            );
          }
        },
        (error) => this._errorHandleService.redirectToNotFound(error),
      );
  }

  async getDadosUsuario(): Promise<void> {
    const companyId = this.authService.companyID;
    const restrictionKey = this.authService.restrictionKey;
    this.userId = this.authService.userID;

    const dataAtual = new Date();

    await this._headerService
      .dadosUsuario(companyId, restrictionKey, this.userId)
      .subscribe(
        (response) => {
          if (response.success) {
            if (this.dataImplementacaoAtualizarCadastro <= dataAtual) {
              this.verificaUsuario();
            }
            this.level = response.data.level;
            this.userName = response.data.name;
            this.exportWork = response.data.exportWork;

            if (this.level !== 'Restrito') {
              this.modulosFornecedor();
            }

            localStorage.setItem('level', response.data.level);
            localStorage.setItem('userName', response.data.name);
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => this._errorHandleService.redirectToNotFound(error),
      );
  }

  async getDadosFornecedor(): Promise<void> {
    const companyId = this.authService.companyID;
    const restrictionKey = this.authService.restrictionKey;

    await this._headerService
      .dadosFornecedor(companyId, restrictionKey)
      .subscribe(
        (response) => {
          if (!response.success) {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => this._errorHandleService.redirectToNotFound(error),
      );
  }

  async modulosFornecedor(): Promise<void> {
    try {
      const response = await this._dashboardService
        .modulosFornecedor(this.companyId, this.restrictionKey)
        .toPromise();

      if (response.success) {
        this.menuModules = response.data;
        if (this.menuModules?.length > 0) {
          this.selecionarIdModulosService.setModulosDisponiveis(
            this.menuModules,
          );
        }
      } else {
        this._errorHandleService.throwConsoleError(response);
      }
    } catch (error) {
      this._errorHandleService.redirectToNotFound(error);
    }
  }

  sair(): void {
    this.authService.logout();
  }
}
